export default (params) => ({
  trigger: {
    name: 'review_panel.sort',
    params: params,
  },
  config: {
    schema: {
      sort_value: {
        type: 'string',
      },
    },
    event: {
      name: 'sort',
      params: {
        sub_feature: null,
      },
    },
  },
});
